"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _moment = require('moment'); var _moment2 = _interopRequireDefault(_moment);



var _timeZones = require('shared/services/timeZones');

// Send later's presets and window, in the time zone the user schedules in.
// Every function takes `now`, so the rules can be checked against any clock.











// "Later today": this many hours out, rounded up to the next half hour, and
// only while that is still within the working day.
const LATER_TODAY_HOURS = 3
const ROUND_TO_MINUTES = 30
const END_OF_DAY_HOUR = 17
const PRESET_HOUR = 9
const MONDAY = 1
const FRIDAY = 5
const SATURDAY = 6
// The server accepts a send time about a minute out (55 s, for the round trip).
const MIN_LEAD_MS = 60 * 1000

const sameDay = (a, b, timeZone) => _timeZones.sameWallDay.call(void 0, _timeZones.wallClock.call(void 0, a, timeZone), _timeZones.wallClock.call(void 0, b, timeZone))

// A wall-clock time some days from now in the zone: its calendar, so a DST
// change in between keeps 9:00 AM at 9:00 AM.
const daysFrom = (now, days, hour, timeZone) =>
  _timeZones.zonedInstant.call(void 0, _timeZones.daysAfter.call(void 0, _timeZones.wallClock.call(void 0, now, timeZone), days, hour), timeZone)

// Null outside a weekday's working hours: the rounded time must land by 5:00 PM.
const laterToday = (now, timeZone) => {
  const today = _timeZones.wallClock.call(void 0, now, timeZone)
  if (today.weekday < MONDAY || today.weekday > FRIDAY) return null
  const target = new Date(now.getTime() + LATER_TODAY_HOURS * 60 * 60 * 1000)
  const step = ROUND_TO_MINUTES * 60 * 1000
  // Rounded on the zone's clock: its minutes, plus the seconds every zone shares.
  const { hour, minute } = _timeZones.wallClock.call(void 0, target, timeZone)
  const offset = (hour * 60 + minute) * 60 * 1000 + (target.getTime() % 60000)
  const rounded = new Date(target.getTime() + (offset % step ? step - (offset % step) : 0))
  const endOfDay = daysFrom(now, 0, END_OF_DAY_HOUR, timeZone)
  return sameDay(rounded, now, timeZone) && endOfDay && rounded.getTime() <= endOfDay.getTime() ? rounded : null
}

const detailFor = (sendAt, now, timeZone) => {
  const tomorrow = _timeZones.daysAfter.call(void 0, _timeZones.wallClock.call(void 0, now, timeZone), 1, 0)
  if (sameDay(sendAt, now, timeZone)) return _timeZones.formatInZone.call(void 0, sendAt, timeZone, 'h:mm A')
  if (_timeZones.sameWallDay.call(void 0, _timeZones.wallClock.call(void 0, sendAt, timeZone), tomorrow)) return _timeZones.formatInZone.call(void 0, sendAt, timeZone, 'ddd h:mm A')
  return _timeZones.formatInZone.call(void 0, sendAt, timeZone, 'ddd, MMM D, h:mm A')
}

/* Slack-style presets, from the clock in the zone the times are in (the
 * device's unless the user picked another): Later today (weekdays, while
 * it lands by 5:00 PM), Tomorrow at 9:00 AM, then Monday at 9:00 AM ("Monday"
 * from Friday and Saturday, "Next Monday" from Monday to Thursday). On a
 * Sunday tomorrow is Monday, so it's listed once. Two or three, plus Custom. */
 const sendLaterPresets = (now, timeZone = _timeZones.deviceTimeZone.call(void 0, )) => {
  const day = _timeZones.wallClock.call(void 0, now, timeZone).weekday
  // The coming Monday: tomorrow on a Sunday, a week out on a Monday.
  const comingMonday = daysFrom(now, ((MONDAY - day + 7) % 7) || 7, PRESET_HOUR, timeZone)
  const presets = [
    { id: 'laterToday', label: 'Later today', sendAt: laterToday(now, timeZone) },
    { id: 'tomorrow', label: 'Tomorrow', sendAt: daysFrom(now, 1, PRESET_HOUR, timeZone) },
    day === FRIDAY || day === SATURDAY
      ? { id: 'monday', label: 'Monday', sendAt: comingMonday }
      : { id: 'nextMonday', label: 'Next Monday', sendAt: comingMonday },
  ]
  const shown = []
  presets.forEach(({ id, label, sendAt }) => {
    // On a Sunday the coming Monday is Tomorrow: list that time once.
    if (!sendAt || shown.some(preset => preset.sendAt.getTime() === sendAt.getTime())) return
    shown.push({ id, label, sendAt, detail: detailFor(sendAt, now, timeZone) })
  })
  return shown
}; exports.sendLaterPresets = sendLaterPresets

 const earliestSendAt = (now) => new Date(now.getTime() + MIN_LEAD_MS); exports.earliestSendAt = earliestSendAt

// One calendar year out, inclusive, as the server counts it.
 const latestSendAt = (now) => _moment2.default.call(void 0, now).add(1, 'year').toDate(); exports.latestSendAt = latestSendAt

// Why a send time can't be used, or null when it can.
 const sendAtProblem = (sendAt, now) => {
  if (Number.isNaN(sendAt.getTime())) return 'Pick a date and time.'
  if (sendAt.getTime() <= now.getTime()) return 'Pick a time in the future.'
  if (sendAt.getTime() < exports.earliestSendAt.call(void 0, now).getTime()) return 'Pick a time at least a minute from now.'
  if (sendAt.getTime() > exports.latestSendAt.call(void 0, now).getTime()) return 'Pick a time within a year from now.'
  return null
}; exports.sendAtProblem = sendAtProblem
